import styled from 'styled-components';

export const BridgeContainer = styled.section`
  background: linear-gradient(180deg, #040000 0%, #030D45 100%);
  padding: 80px 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 50px 0;
    min-height: auto;
  }
  
  @media (max-width: 480px) {
    padding: 40px 0;
  }
`;

export const BridgeContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
  
  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
  
  @media (max-width: 480px) {
    padding: 0 1rem;
  }
`;

export const MainTitle = styled.h2`
  font-size: 3rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    line-height: 1.3;
  }
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
    margin-bottom: 0.8rem;
  }
`;

export const HighlightedText = styled.p`
  font-size: 1.8rem;
  font-weight: 600;
  background: linear-gradient(90deg, #69C9D0 0%, #8B9FF7 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 2rem;
  line-height: 1.3;
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    line-height: 1.4;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
`;

export const PhoneTitle = styled.h4`
  font-size: 1.3rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 2rem;
  line-height: 1.5;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const BottomDescription = styled.p`
  font-size: 1.1rem;
  font-weight: 300;
  color: rgb(255, 255, 255, 0.8);
  line-height: 1.6;
  max-width: 750px;
  margin: 0 auto;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 1.5;
  }
  
  @media (max-width: 480px) {
    font-size: 0.9rem;
    line-height: 1.4;
  }
`;

export const PhoneImage = styled.div`
  img {
    max-width: 980px;
    height: auto;
    
    @media (max-width: 768px) {
      max-width: 300px;
    }
    
    @media (max-width: 480px) {
      max-width: 250px;
    }
  }
`;

export const ContentSection = styled.div`
  max-width: 800px;
  margin: -155px auto;
  padding: 0 2rem;
  text-align: center; 
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  align-items: center;
  margin-bottom: 2rem;
  
  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    margin: -100px auto 2rem auto;
  }
  
  @media (max-width: 768px) {
    margin: -80px auto 1.5rem auto;
    padding: 0 1.5rem;
    gap: 1.5rem;
  }
  
  @media (max-width: 480px) {
    margin: -60px auto 1rem auto;
    padding: 0 1rem;
    gap: 1rem;
  }
`;

export const TextContent = styled.div`
  text-align: left;
  font-size: 1.5rem;
  font-weight: 300;
  color: rgb(255, 255, 255, 0.7);
  margin-bottom: 2rem;
  line-height: 1.2;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 1024px) {
    text-align: center;
    order: 2;
  }
`;

export const AvatarContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 1024px) {
    order: 1;
  }
`;

export const AvatarGroup = styled.div`
  img {
    max-width: 200px;
    height: auto;
    
    @media (max-width: 768px) {
      max-width: 150px;
    }
  }
`;

export const BenefitsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const BenefitIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(90deg, #69C9D0 0%, #8B9FF7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  flex-shrink: 0;
`;

export const BenefitText = styled.p`
  color: #fff;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
  
  @media (max-width: 1024px) {
    text-align: left;
    max-width: 300px;
  }
`;

export const BottomSection = styled.div`
  max-width: 1100px; 
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 35px;
  padding: 3rem;
  margin-top: 4rem;
  
  @media (max-width: 768px) {
    padding: 2rem;
    margin-top: 3rem;
    max-width: 95%;
  }
`;

export const BottomTitle = styled.h3`
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.5rem;
  max-width: 800px;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
export const PhoneImageSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    margin-bottom: 1.5rem;
  }
  
  @media (max-width: 480px) {
    margin-bottom: 1rem;
  }
`;

export const Description = styled.p`
  font-size: 1.0rem;
  font-weight: 300;
  color: rgb(255, 255, 255, 0.7);
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
  
  @media (max-width: 480px) {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.5rem;
  font-weight: 400;
  color: #fff;
  margin-bottom: 1.5rem;
  line-height: 1.4;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  white-space: normal;
  word-break: keep-all;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    line-height: 1.3;
  }
  
  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 0.8rem;
  }
`;